(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('toggle',event=>{const item=event.target;if(!item.matches('.zuqo-mobile-menu__details, .zuqo-mobile-menu__nested-details'))return;item.querySelector(':scope > summary')?.setAttribute('aria-expanded',item.open?'true':'false');if(!item.matches('.zuqo-mobile-menu__details')||!item.open)return;document.querySelectorAll('.zuqo-mobile-menu__details[open]').forEach(opened=>{if(opened!==item)opened.removeAttribute('open')})},true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-bottom-navigation"] && !Shopify.designMode) return;
  try {
    if (/Android/i.test(navigator.userAgent)) {
    document.documentElement.classList.add('zuqo-android');
  }

  if (/FBAN|FBAV|FB_IAB|Instagram/i.test(navigator.userAgent)) {
    document.documentElement.classList.add('zuqo-facebook-in-app');
  }

  const mobileNav = document.querySelector('.zuqo-mobile-bottom-nav');

  if (mobileNav) {
    let previousScrollY = window.scrollY;
    let scrollFrame;

    const updateMobileNavSize = () => {
      const currentScrollY = Math.max(window.scrollY, 0);
      const scrollDifference = currentScrollY - previousScrollY;

      if (currentScrollY < 40) {
        mobileNav.classList.remove('is-compact');
      } else if (scrollDifference > 5) {
        mobileNav.classList.add('is-compact');
      } else if (scrollDifference < -5) {
        mobileNav.classList.remove('is-compact');
      }

      previousScrollY = currentScrollY;
      scrollFrame = null;
    };

    window.addEventListener('scroll', () => {
      if (scrollFrame) return;
      scrollFrame = window.requestAnimationFrame(updateMobileNavSize);
    }, { passive: true });

    const activateMobileNavItem = (item) => {
      mobileNav.querySelectorAll('.zuqo-mobile-bottom-nav__item').forEach((navItem) => navItem.classList.remove('is-active'));
      item?.classList.add('is-active');
    };

    const mobileMenuButton = mobileNav.querySelector('[data-zuqo-mobile-menu]');
    const mobileSearchButton = mobileNav.querySelector('[data-zuqo-mobile-search]');
    const mobileSearchBar = document.querySelector('#ZuqoMobileSearchBar');
    const mobileSearchInput = mobileSearchBar?.querySelector('#ZuqoMobileSearchInput');
    const mobileSearchClose = mobileSearchBar?.querySelector('[data-zuqo-mobile-search-close]');

    mobileMenuButton?.addEventListener('click', () => {
      activateMobileNavItem(mobileMenuButton);
      document.querySelector('#Details-menu-drawer-container > summary')?.click();
    });

    const closeMobileSearch = () => {
      mobileSearchBar?.classList.remove('is-open');
      mobileSearchBar?.setAttribute('aria-hidden', 'true');
      mobileSearchButton?.setAttribute('aria-expanded', 'false');
      mobileSearchButton?.classList.remove('is-active');
    };

    if (document.documentElement.classList.contains('zuqo-facebook-in-app')) {
      let viewportFrame;
      const updateInAppViewport = () => {
        const viewport = window.visualViewport;
        const visualObstruction = viewport ? window.innerHeight - viewport.height - viewport.offsetTop : 0;
        const browserObstruction = Math.max(window.outerHeight - window.innerHeight, 0);
        const activeElement = document.activeElement;
        const keyboardIsOpen = activeElement?.matches('input, textarea, select, [contenteditable="true"]');
        const isObscured = !keyboardIsOpen && Math.max(visualObstruction, browserObstruction) > 150;

        mobileNav.classList.toggle('is-iab-obscured', isObscured);
        if (isObscured) closeMobileSearch();
        viewportFrame = null;
      };

      const requestViewportUpdate = () => {
        if (viewportFrame) return;
        viewportFrame = window.requestAnimationFrame(updateInAppViewport);
      };

      window.visualViewport?.addEventListener('resize', requestViewportUpdate, { passive: true });
      window.visualViewport?.addEventListener('scroll', requestViewportUpdate, { passive: true });
      window.addEventListener('resize', requestViewportUpdate, { passive: true });
      window.setTimeout(updateInAppViewport, 120);
      window.setTimeout(updateInAppViewport, 800);
    }

    mobileSearchButton?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (mobileSearchBar?.classList.contains('is-open')) {
        closeMobileSearch();
        return;
      }

      activateMobileNavItem(mobileSearchButton);
      mobileSearchBar?.classList.add('is-open');
      mobileSearchBar?.setAttribute('aria-hidden', 'false');
      mobileSearchButton.setAttribute('aria-expanded', 'true');
      window.setTimeout(() => mobileSearchInput?.focus(), 180);
    });

    mobileSearchClose?.addEventListener('click', closeMobileSearch);

    document.addEventListener('click', (event) => {
      if (!mobileSearchBar?.classList.contains('is-open')) return;
      if (mobileSearchBar.contains(event.target) || mobileSearchButton?.contains(event.target)) return;
      closeMobileSearch();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && mobileSearchBar?.classList.contains('is-open')) {
        closeMobileSearch();
        mobileSearchButton?.focus();
      }
    });

    const mobileCount = mobileNav.querySelector('[data-zuqo-cart-count]');
    const headerCart = document.querySelector('#cart-icon-bubble');

    const syncCartCount = () => {
      const headerCount = headerCart?.querySelector('.cart-count-bubble span[aria-hidden="true"]');
      const count = headerCount?.textContent?.trim() || '0';
      mobileCount.textContent = count;
      mobileCount.classList.toggle('is-hidden', count === '0');
    };

    if (mobileCount && headerCart) {
      new MutationObserver(syncCartCount).observe(headerCart, { childList: true, subtree: true, characterData: true });
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-short-video"] && !Shopify.designMode) return;
  try {
    const initializeProductVideos = (root = document) => {
    root.querySelectorAll('[data-zuqo-product-video]').forEach((component) => {
      if (component.dataset.videoReady) return;
      component.dataset.videoReady = 'true';
      const dialog = component.querySelector('[data-zuqo-video-dialog]');
      const player = component.querySelector('.zuqo-product-video__player');
      const openButton = component.querySelector('[data-zuqo-video-open]');
      const closeButton = component.querySelector('[data-zuqo-video-close]');
      const closeVideo = () => {
        player?.pause();
        if (dialog?.open) dialog.close();
        document.body.classList.remove('overflow-hidden');
      };
      openButton?.addEventListener('click', () => {
        if (!dialog) return;
        dialog.showModal();
        document.body.classList.add('overflow-hidden');
        player?.play().catch(() => {});
      });
      closeButton?.addEventListener('click', closeVideo);
      dialog?.addEventListener('click', (event) => {
        if (event.target === dialog) closeVideo();
      });
      dialog?.addEventListener('close', () => {
        player?.pause();
        document.body.classList.remove('overflow-hidden');
      });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeProductVideos());
  } else {
    initializeProductVideos();
  }
  document.addEventListener('shopify:section:load', (event) => initializeProductVideos(event.target));
  } catch(e) { console.error(e); }
})();

})();
